import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import * as globals from './components/GlobalScripts.js';
import './styles/GlobalStyles.css';
import ScrollToTop from './pages/ScrollToTop';
import Profesional from './pages/Profesional';
import Profesional_home from './pages/profesional/Profesional_home';
import Profesional_cuenta from './pages/profesional/Profesional_cuenta';
import Profesional_direccion from './pages/profesional/Profesional_direccion';
import Profesional_perfil from './pages/profesional/Profesional_perfil';
import Profesional_portafolio from './pages/profesional/Profesional_portafolio';
import Profesional_MetodoDePago from './pages/profesional/Profesional_MetodoDePago';
import Profesional_Membresia from './pages/profesional/Profesional_Membresia';
import Profesional_Membresia_TY from './pages/profesional/Profesional_Membresia_TY';
import Cliente from './pages/Cliente';
import Cliente_home from './pages/cliente/Cliente_home';
import Cliente_cuenta from './pages/cliente/Cliente_cuenta';
import Cliente_direccion from './pages/cliente/Cliente_direccion';
import Admin from './pages/Admin';
import Admin_cuentas from './pages/admin/Admin_cuentas';
import Nuevo_profesional from './pages/admin/Nuevo_profesional';
import Admin_cuentas_edit from './pages/admin/Admin_cuentas_edit';
import Admin_mensajes from './pages/admin/Admin_mensajes';
import Admin_chat_history from './pages/admin/Admin_chat_history';
import Admin_reviews from './pages/admin/Admin_reviews';
import Admin_reviews_edit from './pages/admin/Admin_reviews_edit';
import Admin_pagos_de_clientes from './pages/admin/Admin_pagos_de_clientes';
import Admin_pagos_de_clientes_edit from './pages/admin/Admin_pagos_de_clientes_edit';
import Admin_reportes from './pages/admin/Admin_reportes';
import Admin_reportes_cuentas from './pages/admin/Admin_reportes_cuentas';
import Admin_reportes_mensajes from './pages/admin/Admin_reportes_mensajes';
import Admin_reportes_propuestas from './pages/admin/Admin_reportes_propuestas';
import Admin_reportes_pagos from './pages/admin/Admin_reportes_pagos';
import Admin_reportes_reviews from './pages/admin/Admin_reportes_reviews';
import Admin_reportes_notifications from './pages/admin/Admin_reportes_notifications';
import Admin_categorias from './pages/admin/Admin_categorias';
import Chat from './pages/Chat';
import Chat_home from './pages/chat/Chat_home';
import Home from './pages/Home';
import Categorias from './pages/Categorias';
import Servicios from './pages/Servicios';
import Profesional_home_public from './pages/profesional/Profesional_home_public';
import Quiero_contratar from './pages/Quiero_contratar';
import Quiero_trabajar from './pages/Quiero_trabajar';
import Login from './pages/Login';
import Restore_password from './pages/Restore_password';
import Terminos_condiciones from './pages/Terminos_condiciones';
import PoliticasPrivacidad from './pages/PoliticasPrivacidad';
import PoliticaCookies from './pages/PoliticaCookies';
import OfertaProfesional from './pages/OfertaProfesional';
import Configure_account from './pages/Configure_account';

const PrivateRoute = ({ children }) => {
    return globals.isAuthenticated() ? children : <Navigate to="/login" replace />;
};

const PrivateRouteAdmin = ({ children }) => {
    const user = JSON.parse(localStorage.getItem('user'));

    return globals.isAuthenticated() && user?.rol == 4 ? children : <Navigate to="/login" replace />;
};

function App() {
    localStorage.setItem('path_api', 'https://donhonesto.com/backend');

    useEffect(() => {
        globals.closeViewCharge();
    }, []);

    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route
                    path="/profesional/*"
                    element={
                        <PrivateRoute>
                            <Profesional />
                        </PrivateRoute>
                    }
                >
                    <Route index element={<Profesional_home />} />
                    <Route path="cuenta" element={<Profesional_cuenta />} />
                    <Route path="direccion" element={<Profesional_direccion />} />
                    <Route path="perfil" element={<Profesional_perfil />} />
                    <Route path="portafolio" element={<Profesional_portafolio />} />
                    <Route path="metodo-de-pago" element={<Profesional_MetodoDePago />} />
                    <Route path="membresia" element={<Profesional_Membresia />} />
                    <Route path="membresia/ty" element={<Profesional_Membresia_TY />} />
                </Route>
                <Route
                    path="/cliente/*"
                    element={
                        <PrivateRoute>
                            <Cliente />
                        </PrivateRoute>
                    }
                >
                    <Route index element={<Cliente_home />} />
                    <Route path="cuenta" element={<Cliente_cuenta />} />
                    <Route path="direccion" element={<Cliente_direccion />} />
                </Route>
                <Route
                    path="/chat/:id"
                    element={
                        <PrivateRoute>
                            <Chat />
                        </PrivateRoute>
                    }
                >
                    <Route index element={<Chat_home />} />
                </Route>
                <Route
                    path="/admin/*"
                    element={
                        <PrivateRouteAdmin>
                            <Admin />
                        </PrivateRouteAdmin>
                    }
                >
                    <Route path="cuentas" element={<Admin_cuentas />} />
                    <Route path="nuevo-profesional" element={<Nuevo_profesional />} />
                    <Route path="cuentas/:id" element={<Admin_cuentas_edit />} />
                    <Route path="mensajes" element={<Admin_mensajes />} />
                    <Route path="chat-history/:id/:id2" element={<Admin_chat_history />} />
                    <Route path="reviews" element={<Admin_reviews />} />
                    <Route path="reviews/:id" element={<Admin_reviews_edit />} />
                    <Route path="reviews/:dummy/:id" element={<Admin_cuentas_edit />} />
                    <Route path="pagos-de-clientes" element={<Admin_pagos_de_clientes />} />
                    <Route path="pagos-de-clientes/:id" element={<Admin_pagos_de_clientes_edit />} />
                    <Route path="pagos-de-clientes/:dummy/:id" element={<Admin_cuentas_edit />} />
                    <Route path="reportes" element={<Admin_reportes />} />
                    <Route path="reportes/cuentas" element={<Admin_reportes_cuentas />} />
                    <Route path="reportes/mensajes" element={<Admin_reportes_mensajes />} />
                    <Route path="reportes/propuestas" element={<Admin_reportes_propuestas />} />
                    <Route path="reportes/pagos-de-clientes" element={<Admin_reportes_pagos />} />
                    <Route path="reportes/reviews" element={<Admin_reportes_reviews />} />
                    <Route path="reportes/notificaciones" element={<Admin_reportes_notifications />} />
                    <Route path="categorias" element={<Admin_categorias />} />
                </Route>
                <Route path="/" element={<Home />} />
                <Route path="/solicitar" element={<Servicios />} />
                <Route path="/categorias" element={<Categorias />} />
                <Route path="/categorias/:categoria" element={<Categorias />} />
                <Route path="/servicios" element={<Servicios />} />
                <Route path="/servicios/:categoria" element={<Servicios />} />
                <Route path="/ver/profesional/:id" element={<Profesional_home_public />} />
                <Route path="/quiero-contratar" element={<Quiero_contratar />} />
                <Route path="/quiero-trabajar" element={<Quiero_trabajar />} />
                <Route path="/login" element={<Login />} />
                <Route path="/restaurar-contraseña" element={<Restore_password />} />
                <Route path="/terminos-condiciones" element={<Terminos_condiciones />} />
                <Route path="/terminos-y-condiciones" element={<Terminos_condiciones />} />
                <Route path="/politicas-de-privacidad" element={<PoliticasPrivacidad />} />
                <Route path="/politica-de-cookies" element={<PoliticaCookies />} />
                <Route path="/oferta-profesionales" element={<OfertaProfesional />} />
                <Route path="/m/ca/:id" element={<Configure_account />} />
            </Routes>
        </Router>
    );
}

export default App;
